import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export const useUnseenFeedCount = (userId: string | undefined) => {
  return useQuery({
    queryKey: ["unseen-feed-count", userId],
    queryFn: async () => {
      if (!userId) return 0;

      // Get user's last_feed_check timestamp
      const { data: profile, error: profileError } = await supabase
        .from("profiles")
        .select("last_feed_check")
        .eq("id", userId)
        .single();

      if (profileError) throw profileError;

      // Count feed items created after last_feed_check
      const query = supabase
        .from("feed_items")
        .select("id", { count: "exact", head: true })
        .eq("user_id", userId);

      // Only filter by last_feed_check if it exists
      if (profile?.last_feed_check) {
        query.gt("created_at", profile.last_feed_check);
      }

      const { count, error } = await query;

      if (error) throw error;
      return count || 0;
    },
    enabled: !!userId,
    refetchInterval: 30000, // Refetch every 30 seconds
  });
};
